import { PayloadAction } from 'typesafe-actions';
import { AccountDetailsContextActionTypes, AccountDetailsState } from './types';

const AccountDetailsReducer = (
  state: AccountDetailsState,
  action: PayloadAction<AccountDetailsContextActionTypes, any>,
): AccountDetailsState => {
  switch (action.type) {
    case AccountDetailsContextActionTypes.SetSelectedAccountDetails:
      return {
        ...state,
        selectedAccountDetails: action.payload,
      };

    case AccountDetailsContextActionTypes.SetSelectedAccount:
      return {
        ...state,
        selectedAccount: action.payload,
      };
    case AccountDetailsContextActionTypes.setAccountExtraitTransactionListFilters:
      return {
        ...state,
        accountExtraitTransactionListFilters: action.payload,
      };
    case AccountDetailsContextActionTypes.setLastPaginationPageVisited:
      return {
        ...state,
        lastPaginationPageVisited: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { AccountDetailsReducer };
